import type { CourseTypes, ModalityTypes } from '@/models/catalog/course';

export enum AcademicStatusType {
  Pending = 'pending',
  EnrollmentPending = 'enrollment_pending',
  InProgress = 'in_progress',
  Interrupted = 'interrupted',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum AcademicStatusLabel {
  Pending = 'Inscrição em andamento',
  EnrollmentPending = 'Matrícula pendente',
  InProgress = 'Em andamento',
  Interrupted = 'Curso interrompido',
  Canceled = 'Inscrição cancelada',
  Completed = 'Curso concluído',
}

export enum EmbeddedCourseSource {
  InternalCatalog = 'internal_catalog',
  ManualInsertion = 'manual_insertion',
}

export enum EmbeddedCourseProviderType {
  Hosted = 'hosted',
  ThirdParty = 'third_party',
}

export interface AcademicEmbeddedCourse {
  id: string;
  name: string;
  institution_name: string | null;
  course_type: CourseTypes;
  modality: ModalityTypes;
  duration: number | null;
  duration_type: string | null;
  source: EmbeddedCourseSource;
  provider_type: EmbeddedCourseProviderType;
  external_institution_logo_url: string | null;
  external_institution_background_color: string | null;
}

export interface AcademicSituation {
  id: string;
  current_status: AcademicStatusType;
  started_at: string | null;
  estimated_conclusion: string | null;
  created_at: string;
  embedded_course: AcademicEmbeddedCourse;
}

export interface AcademicStatusDocument {
  url: string;
  filename: string;
  byte_size: number;
  content_type: string;
}

export enum AcademicStatusSource {
  CourseApplication = 'course_application',
  ManualInsertion = 'manual_insertion',
  RefundRequest = 'refund_request',
  InstitutionIntegration = 'institution_integration',
}

export interface AcademicStatus {
  id: number;
  status_type: AcademicStatusType;
  source: AcademicStatusSource;
  title: string;
  subtitle: string | null;
  occurred_at: string;
  documents: AcademicStatusDocument[];
}

export interface AcademicSituationDetails extends AcademicSituation {
  statuses: AcademicStatus[];
}

export interface CreateAcademicSituationPayload {
  institution_name: string;
  course_name: string;
  course_type: string;
  modality: string;
  duration_unit?: number | null;
  duration_type?: string | null;
  workload?: number | null;
  link?: string | null;
  status_type?: AcademicStatusType;
}
